import { Shield, Sparkles, Zap, ZapOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/ThemeToggle";
import { useReducedMotion } from "@/hooks/useReducedMotion";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface HeaderProps {
  onQuickScan?: () => void;
  showQuickScan?: boolean;
}

export function Header({ onQuickScan, showQuickScan = true }: HeaderProps) {
  const { reducedMotion, toggle } = useReducedMotion();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-card border-b border-border/50">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary to-accent flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-primary-foreground" />
          </div>
          <div>
            <h1 className="text-lg font-display font-bold gradient-text">ASCENTION</h1>
            <p className="text-xs text-muted-foreground">Facial Analysis</p>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <div className="hidden sm:flex items-center gap-2 text-xs text-muted-foreground">
            <Shield className="w-4 h-4 text-success" />
            <span>100% Private • Client-Side</span>
          </div>

          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="h-9 w-9"
                onClick={toggle}
                aria-label={reducedMotion ? "Enable animations" : "Reduce animations"}
              >
                {reducedMotion ? <ZapOff className="h-4 w-4" /> : <Zap className="h-4 w-4" />}
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              {reducedMotion ? "Animations off" : "Animations on"}
            </TooltipContent>
          </Tooltip>
          
          <ThemeToggle />
          
          {showQuickScan && onQuickScan && (
            <Button variant="heroOutline" size="sm" onClick={onQuickScan}>
              Quick Scan
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
